import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '../store';

// Base selector for uiSettings state
const selectUiSettings = (state: RootState) => state.uiSettings;

// Selector for all gear options
export const selectGearOptions = createSelector(
  [selectUiSettings],
  (uiSettings) => uiSettings.gearOptions
);

// Selector for reference type
export const selectReferenceType = createSelector(
  [selectUiSettings],
  (uiSettings) => uiSettings.referenceType
);

// Selector for the in-shell Customize sheet open state (#5238)
export const selectCustomizeSheetOpen = createSelector(
  [selectUiSettings],
  (uiSettings) => uiSettings.customizeSheetOpen
);
